import React from "react";
import { Grid, Typography, Button, Divider } from "@material-ui/core";
import ThresholdTierRow from "./ThresholdTierRow";

const ThresholdSection = ({ title, values, setValues, defaults, disabled, errors, classes }) => {
  return (
    <div className={classes.sectionWrapper}>
      <Typography variant="h6" color="primary" component="h5">
        {title}
      </Typography>
      <Divider className={classes.sectionDivider} />

      <Grid container spacing={1}>
        <ThresholdTierRow
          tierLabel="Tier 1"
          isDefault
          color={values.tier1Color}
          disabled={disabled}
          onColorChange={(val) => setValues({ ...values, tier1Color: val })}
          classes={classes}
        />
        <ThresholdTierRow
          tierLabel="Tier 2"
          label="At or above"
          value={values.tier2Value}
          color={values.tier2Color}
          disabled={disabled}
          error={errors?.tier2Value}
          onValueChange={(val) => setValues({ ...values, tier2Value: val })}
          onColorChange={(val) => setValues({ ...values, tier2Color: val })}
          classes={classes}
        />
        <ThresholdTierRow
          tierLabel="Tier 3"
          label="At or above"
          value={values.tier3Value}
          color={values.tier3Color}
          disabled={disabled}
          error={errors?.tier3Value}
          onValueChange={(val) => setValues({ ...values, tier3Value: val })}
          onColorChange={(val) => setValues({ ...values, tier3Color: val })}
          classes={classes}
        />
      </Grid>

      <Button
        size="small"
        color="primary"
        className={classes.defaultColorsBtn}
        disabled={disabled}
        onClick={() =>
          setValues({
            ...values,
            tier1Color: defaults[0],
            tier2Color: defaults[1],
            tier3Color: defaults[2]
          })
        }
      >
        Default Colors
      </Button>
    </div>
  );
};

export default ThresholdSection;
